module.exports = __webpack_public_path__ + "static/media/bt.87d65251.svg";